import React from 'react';
import { Link } from 'react-router-dom';
import { getSubdomainUrl, isCrossSubdomain } from '../utils/subdomain';

const SubdomainLink = ({ to, children, ...props }) => {
  // If target path crosses subdomains, use native <a> tag with absolute subdomain URL
  if (isCrossSubdomain(to)) {
    return (
      <a href={getSubdomainUrl(to)} {...props}>
        {children}
      </a>
    );
  }

  // Otherwise, use client-side react-router Link
  return (
    <Link to={to} {...props}>
      {children}
    </Link>
  );
};

export default SubdomainLink;
export { SubdomainLink };
